import axios from "axios";

export const state = {
    schoolclasses: [],
};

export const getters = {
    schoolclasses: state => state.schoolclasses,
};

export const mutations = {
    setClasses(state, newValue) {
        state.schoolclasses = newValue
    },
};

export const actions = {
    fetchSchoolClasses({ commit }) {
        axios.get('/schoolclasses').then(res => {
            commit('setClasses', res.data.schoolclasses);
        })
    },
};
